import {Drawer, DrawerProps, ScrollArea} from '@mantine/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {Meter} from "../types.ts";

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: Meter,
        handleSubmit: (values: Meter) => void
    }) => {

    const title = record?.id ? `Edit Meter` : `Add Meter`;

    const handleFormSubmit = async (values: Meter) => {
        await handleSubmit(values);
        onClose();
    };

    return (
        <Drawer
            transitionProps={{
                transition: "slide-left",
                duration: 750,
                timingFunction: "ease"
            }}
            position="right"
            offset={10}
            opened={opened}
            onClose={onClose}
            title={title}
            padding="xl"
            size="xl"
            scrollAreaComponent={ScrollArea.Autosize}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </Drawer>
    )
};
